import development from './development'
import production from './production'

const { NODE_ENV } = process.env

export default {
  development,
  production
}[NODE_ENV || 'production']
